import { FC } from 'react'

import { Container } from 'components/container'
import { Links, Logo, StyledFooter } from './styled'
import { useAppContext } from 'context/app-context'
import { Share } from '../share'

type Props = {}

export const Footer: FC<Props> = () => {
  const { logoUrl } = useAppContext()

  return (
    <StyledFooter>
      <Container>
        <Links>
          <li>
            <a href="https://pressroom.rferl.org/service/votvot/" target="_blank">
              О проекте
            </a>
          </li>
          <li>
            <a href="https://www.votvot.tv/a/mail-us/32948185.html">
              Напишите нам
            </a>
          </li>
          <li>
            <a href="https://www.votvot.tv/a/32892639.html">
              Правила защиты персональных данных
            </a>
          </li>
        </Links>
        <Share isVisible />
        <Logo src={logoUrl} />
      </Container>
    </StyledFooter>
  )
}
